import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { httpGet, crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";
import { languagePicker, getLabel, removeIgnoreItems, setImgSrcSize } from '../../utils';
import YTVideo from '../../components/YTVideo/YTVideo';
import SharePage from '../../components/SharePage/SharePage';
import LandingPageHolder from './LandingPageStyle';
import ListItem from '../../components/ListItem/ListItem';
import Video from '../../components/Video/Video';
import SEO from '../../components/SEO/SEO';

const LandingPage = (props) => {
    const [header, setHeader] = useState({ title: "", descripcion: "", imagePath: "", altImage: "" });
    const [banner, setBanner] = useState({});
    const [pageDetails, setPageDetails] = useState([]);
    const [type, setType] = useState("NONE");
    const [about, setAbout] = useState("");
    const [talents, setTalents] = useState([]);
    const [interviewsYoutubePlaylist, setInterviewsYoutubePlaylist] = useState([]);
    const [explainersYoutubePlaylist, setExplainersYoutubePlaylist] = useState([]);
    const [latestVideos, setLatestVideos] = useState([]);
    const [aboutOpen, setAboutOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [pageThumb, setPageThumb] = useState();
    const [isLive, setIsLive] = useState("");
    const [pageDesc, setPageDesc] = useState();
    const siteURL = window.location.origin;
    const pageURL = window.location.origin + window.location.pathname;
    const pageLang = props.current_lang;
    const pageLocale = pageLang + "_CA";
    const pageTitle = header.title + " | CPAC.ca";
    

    useEffect(() => {
        const craftConf = crafterConf.getConfig();
        const serviceUrl = composeUrl(craftConf, process.env.REACT_APP_CONTENT_MODEL_ENDPOINT);

        httpGet(serviceUrl, { url: props.url, crafterSite: craftConf.site }).subscribe((data) => {
            let fieldNames = [
                "landingPage;about_program_html", "landingPage;altImageTxt_s", "landingPage;title_t", "landingPage;description_html", "landingPage;image_s",
                "explainers_youtube_playlist_o;title_s", "interviews_youtube_playlist_o;title_s", "talents.bios_html",
                "details;title_t", "details;description_t", "details;category_t", "details;image_s", "details;altImageTxt_s", "details;categoryURL_s",
                "itemList;seeAllUrl_s", "itemList;title_t", "itemList.altImageTxt_s", "itemList.categoryURL_s", "itemList.category_t",
                "itemList.description_t", "itemList.image_s", "itemList.title_t", "itemList.url_s",
                "thumbnailResult.image_s", "thumbnailResult.altImageTxt_s", "metaDescription_t"
            ]
            data.page.explainers_youtube_playlist_o = data.page.landingPage.explainers_youtube_playlist_o
            data.page.interviews_youtube_playlist_o = data.page.landingPage.interviews_youtube_playlist_o
            data.page.talents = data.page.landingPage.talents
            if (data.page.talents) {
                data.page.talents.item = removeIgnoreItems(data.page.talents)
            }

            if (data.page.landingPage.details) {
                data.page.details = data.page.landingPage.details
            }

            if (data.page.landingPage.itemList) {
                data.page.itemList = data.page.landingPage.itemList
            }

            languagePicker(data, fieldNames);
            let dataPage = data.page;
            setType(dataPage.landingPage.content_placeholder_s);
            setPageDesc(dataPage.metaDescription);

            if (dataPage.thumbnailResult && dataPage.thumbnailResult.item) {
                setBanner(dataPage.thumbnailResult.item[0])
            }

            // Setting Up Header
            let headerTemp = { title: "", descripcion: "", imagePath: "", altImage: "" };
            headerTemp.title = dataPage.landingPage.title;
            headerTemp.descripcion = dataPage.landingPage.description;

            if (dataPage.landingPage.content_placeholder_s === "THUMBNAIL") {
                // Set all the variables to display Landing Page Header
                headerTemp.imagePath = dataPage.landingPage.image;
                headerTemp.altImage = dataPage.landingPage.altImageTxt;
            } else if (dataPage.landingPage.content_placeholder_s === "VIDEO") {
                setPageDetails(dataPage.details);
                setIsLive(dataPage.landingPage.isLive);
            } else if (dataPage.landingPage.content_placeholder_s === "CPACTV") {
                setPageDetails(dataPage.details);
                setIsLive(dataPage.landingPage.isLive);
            }
            setHeader(headerTemp);
            setAbout(dataPage.landingPage.about_program);

            if (dataPage.talents != null) {
                setTalents(dataPage.talents.item);
            }

            // Setting Up Interviews Youtube Playlist
            setInterviewsYoutubePlaylist(dataPage.interviews_youtube_playlist_o)
            setExplainersYoutubePlaylist(dataPage.explainers_youtube_playlist_o)
            setLatestVideos(dataPage.itemList);
            // set thumbnail for landing pages for SEO - more to get this to work properly
            if (pageLang === "fr") {
                setPageThumb(dataPage.program_o.item[0].component.thumbnail_o.item[0].component.image_fr_s);

            } else {
                setPageThumb(dataPage.program_o.item[0].component.thumbnail_o.item[0].component.image_en_s);
            }
        });
    }, [props.url, props.current_lang]);

    useEffect(() => {
        props.setCurrentLanguage(props.lan);
    }, [props.lan]);

    const renderHeader = () => {
        if (type === "THUMBNAIL") {
            return (
                <>
                    <div className="bg-white lp-thumbnail-container">
                        <div className="lp-thumbnail">
                            <img src={setImgSrcSize(header.imagePath, "lg")} alt={header.altImage} itemProp="thumbnail" />
                        </div>
                    </div>
                    <span>
                        <div className="lp-podcasts" dangerouslySetInnerHTML={{ __html: header.descripcion }} itemProp='about'></div>
                    </span>
                </>
            )
        } else if (type === "VIDEO") {
            return (
                <>
                    <div className="bg-white lp-video-container" itemProp="episode">
                        <div className="lp-video-player">
                            {pageDetails && <Video details={pageDetails} isLanding={true} />}
                            {isLive && isLive === "true" ? 
                            <div className="video-live-label">
							    <img src="/static-assets/theme/svg/target.svg" alt="target-icon" />
							    <span>{getLabel("LIVE")}</span>
						    </div>
                            : ''
                            }
                        </div>
                    </div>
                    <span>
                        <div className="lp-podcasts" dangerouslySetInnerHTML={{ __html: header.descripcion }} itemProp='about'></div>
                    </span>
                </>
            )
        } else if (type === "CPACTV") {
            return (
                <>
                    <div className="bg-white lp-video-container" itemProp='episode'>
                        <div className="lp-video-player">
                            {pageDetails && <Video details={pageDetails} isLanding={true} />}
                            <div className="video-live-label">
							    <img src="/static-assets/theme/svg/target.svg" alt="target-icon" />
							    <span>{getLabel("LIVE")}</span>
						    </div>
                        </div>
                    </div>
                    <span>
                        <div className="lp-podcasts" dangerouslySetInnerHTML={{ __html: header.descripcion }}></div>
                    </span>
                </>
            )
        } else if (type === "NONE") {
            return (
                <span>
                    <div className="lp-podcasts" dangerouslySetInnerHTML={{ __html: header.descripcion }}itemProp='about'></div>
                </span>
            );
        }
    }

    const renderTalents = () => {
        return talents.map((result, i) => {
            return (
                <div className="host-bio" key={i}>
                    <h2 className="lp-about-host-label">{getLabel("HOST_BIO")}</h2>
                    <h3 itemProp='actor' itemScope="itemscope" itemType='https://schema.org/Person'><span itemProp='givenName'>{result.first_name_s}</span> <span itemProp='familyName'>{result.last_name_s}</span></h3>
                    <div itemProp="description" dangerouslySetInnerHTML={{ __html: result.bios }}></div>
                </div>
            )
        });
    }

    const handleOpenAbouts = (e) => {
        e.preventDefault();
        return setAboutOpen(!aboutOpen);
    }
    const showHostBioLabel = () => {
        return <span>| {getLabel("HOST_BIO")}</span>;
    }

    return (
        <>
            <SEO pageDesc={pageDesc} pageURL={pageURL} title={header.title} pageTitle={pageTitle} image={siteURL + pageThumb} type="video.tv_show" pageLocale={pageLocale} />
            <LandingPageHolder>
                <div itemScope="itemscope" itemType="https://schema.org/TVSeries">
                    <div className="row">
                        <h1 className="page-title" tabIndex="0" itemProp="headline">{header.title}</h1>
                    </div>
                    <div className="row bg-white">
                        {banner && <img src={banner.image} alt={banner.altImageTxt} />}
                    </div>
                    {renderHeader()}
                    {about !== "" &&
                        <div>
                            <p className="lp-aboutLinks">
                                <button className="btn--abouts" onClick={(e) => handleOpenAbouts(e)}>{getLabel("ABOUT")} {header.title} {talents.length > 0 && showHostBioLabel()}</button>
                            </p>
                            <div className={`lp-abouts ${aboutOpen ? '' : 'closed'}`}>
                                <div className={`lp-aboutShow ${talents.length > 0 ? '' : 'full'}`} dangerouslySetInnerHTML={{ __html: about }} itemProp="about"></div>
                                {talents.length > 0 &&
                                    <div className="lp-aboutHost" itemProp='actors'>{renderTalents()}</div>
                                }

                            </div>
                        </div>
                    }
                    <SharePage />
                    <div>
                        {interviewsYoutubePlaylist && <YTVideo selected={selected} setSelected={(val) => setSelected(val)} playlistId={interviewsYoutubePlaylist.playlist_Id_s} title={interviewsYoutubePlaylist.title} />}
                    </div>
                    <div>
                        {latestVideos && <ListItem items={latestVideos} />}
                    </div>
                    <div>
                        {explainersYoutubePlaylist && <YTVideo selected={selected} setSelected={(val) => setSelected(val)} playlistId={explainersYoutubePlaylist.playlist_Id_s} title={explainersYoutubePlaylist.title} />}
                    </div>
                </div>
            </LandingPageHolder>
        </>
    )
}

const mapStateToProps = (store) => ({
    current_lang: store.language.current,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentLanguage: (lang) => dispatch({ type: 'SET_CUR_LANG', current: lang })
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);